import { render, staticRenderFns } from "./MemberCollectRecords.vue?vue&type=template&id=186db49a&scoped=true&"
import script from "./MemberCollectRecords.vue?vue&type=script&lang=js&"
export * from "./MemberCollectRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186db49a",
  null
  
)

component.options.__file = "MemberCollectRecords.vue"
export default component.exports